import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-manufacturing',
  templateUrl: './page-manufacturing.component.html',
  styleUrls: ['./page-manufacturing.component.css']
})

/**
 * page Blog-Detail-Two Component
 */
export class PageManufacturingComponent implements OnInit {

      // Set Topbar Option
  Menuoption = 'center';
  Settingicon = false
  /**
   * Nav Light Class Add
   */
  navClass = 'nav-light';

  constructor() { }

  ngOnInit(): void {
  }


}
